import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="m3 17 2 2 4-4"/>
  <path d="m3 7 2 2 4-4"/>
  <path d="M13 6h8"/>
  <path d="M13 12h8"/>
  <path d="M13 18h8"/>
</svg>`;

const Checklist = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='checklist' svg={svg} {...props} />
  )
);

Checklist.displayName = 'ChecklistIcon';

export default Checklist;
